import $ from '../utils/jquery';
const $navbar = $( '#site-navbar' );
const $navbarToggle = $navbar.find( '#navbar-toggle' );
const $navbarCollapse = $( '#navbar-collapse' );

const collapseMenu = () => {
	const height = $navbarCollapse.get( 0 ).scrollHeight;

	$navbarCollapse
		.css( {
			height
		} )
		.addClass( 'collapsing' )
		.removeClass( 'expanded' );

	$navbarCollapse.animate( {
		height: 0
	}, 300, () => {
		$navbarCollapse
			.removeClass( 'collapsing' )
			.addClass( 'collapsed' )
			.removeAttr( 'style' );

		$navbarToggle.attr( 'aria-expanded', 'false' );
	} );
};

const expandMenu = () => {
	$navbarCollapse
		.css( {
			display: 'block',
			height: 0
		} )
		.addClass( 'expanding' )
		.removeClass( 'collapsed' );

	const height = $navbarCollapse.get( 0 ).scrollHeight;

	$navbarCollapse.animate( {
		height
	}, 300, () => {
		$navbarCollapse
			.removeClass( 'expanding' )
			.addClass( 'expanded' )
			.removeAttr( 'style' );

		$navbarToggle.attr( 'aria-expanded', 'true' );
	} );
};

const toggleMenu = () => {
	if ( $navbarCollapse.hasClass( 'collapsing' ) || $navbarCollapse.hasClass( 'expanding' ) ) {
		return;
	}

	if ( $navbarCollapse.hasClass( 'expanded' ) ) {
		collapseMenu();
	}

	if ( $navbarCollapse.hasClass( 'collapsed' ) ) {
		expandMenu();
	}
};

const bind = () => {
	$navbarToggle.on( 'click', () => {
		toggleMenu();
	} );
};

export default () => {
	bind();
};
